import { Button, DialogContentText } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import AssignProductDialog from "@saleor/components/AssignProductDialog";
import { DEFAULT_INITIAL_SEARCH_DATA } from "@saleor/config";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { createPaginationState } from "@saleor/hooks/usePaginator";
// import InstagramTagAddDialog from "@saleor/instagram/components/InstagramTagAddDialog";
// import InstagramTagUpdateDialog from "@saleor/instagram/components/InstagramTagUpdateDialog";
import {
  useInstagCreateMutation,
  useInsTagDeleteMutation,
  useInstagramBulkDeleteTagMutation,
  useInstagramCreateProductinsMutation,
  useInstagramUpdate,
  useInsTagUpdateMutation,
  useUnassignInstagramProductMutation
} from "@saleor/instagram/mutations";
import {
  InstagramPathUrlQueryParams,
  instagramUrl,
  InstagramUrlDialog
} from "@saleor/instagram/urls";
import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { productUrl } from "@saleor/products/urls";
import useProductSearch from "@saleor/searches/useProductSearch";
import useProductVariantSearch from "@saleor/searches/useProductVariantSearch";
import ShipmentDetailsPage from "@saleor/shipment/components/ShipmentDetailsPage";
import { useShipmentDetailsQuery } from "@saleor/shipment/queries";
import {
  shipmentListUrl,
  shipmentPathUrlQueryParams
} from "@saleor/shipment/urls";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React from "react";
// import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
// import { shipmentListUrl } from "@saleor/shipment/urls";

interface ShipmentDetailsProps {
  id: string;
  params: shipmentPathUrlQueryParams;
}

export const ShipmentDetails: React.FC<ShipmentDetailsProps> = ({
  id,
  params
}) => {
  const navigate = useNavigator();

  const notify = useNotifier();

  const { data, loading } = useShipmentDetailsQuery({
    variables: { id }
  });

  const intl = useIntl();

  // const [, setProductVariant] = useState<string>("None");

  const [updateInstagram, updateInstagramOpts] = useInstagramUpdate({
    onCompleted: data => {
      if (data.inseditUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
      }
    }
  });

  const handleSubmit = async () => {
    const result = await updateInstagram({
      // variables: {
      //   id,
      //   input: {
      //     published: data.published,
      //     image: data.image
      //   }
      // }
    });
    return result.data.inseditUpdate.errors;
  };

  const [openModal, closeModal] = createDialogActionHandlers<
    InstagramUrlDialog,
    InstagramPathUrlQueryParams
  >(navigate, params => instagramUrl(id, params), params);

  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    (() => {
      if (typeof params?.ids !== "string") {
        return params.ids;
      } else {
        return ([params.ids] as unknown) as string[];
      }
    })()
  );
  const [
    unassignProduct,
    unassignProductOpts
  ] = useUnassignInstagramProductMutation({
    onCompleted: data => {
      if (data.instagramRemoveProducts.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Deleted product from Instagarm"
          })
        });
        reset();
        closeModal();
      }
    }
  });

  const [
    instagramBulkDeleteTag,
    instagramBulkDeleteTagOpts
  ] = useInstagramBulkDeleteTagMutation({
    onCompleted: data => {
      if (data.instagramBulkDeleteTag.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Deleted tag from Instagarm"
          })
        });
        navigate(instagramUrl(id), true);
      }
    }
  });

  const [
    assignProductIns,
    assignProductInsOpts
  ] = useInstagramCreateProductinsMutation({
    onCompleted: data => {
      if (data.instagramAddProductCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Added Product to Ins"
          })
        });
        navigate(instagramUrl(id), true);
      }
    }
  });

  const paginationState = createPaginationState(8, params);

  const { search, loadMore, result } = useProductSearch({
    variables: {
      after: null,
      first: 8,
      query: ""
    }
  });

  const [] = useInstagCreateMutation({
    onCompleted: data => {
      if (data.instagCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Added Product to Ins"
          })
        });
        navigate(instagramUrl(id), true);
      }
    }
  });

  const {
    loadMore: loadMoreVariants,
    search: searchVariants,
    result: resultVariants
  } = useProductVariantSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });

  const variants = maybe(() => resultVariants.data.search.edges, []).map(
    edge => edge.node
  );

  const [instagramTagDelete] = useInsTagDeleteMutation({
    onCompleted: data => {
      if (data.instagDelete.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "tag deleted",
            description: "instagram tag deleted"
          })
        });
        navigate(instagramUrl(id));
      }
    }
  });

  const [] = useInsTagUpdateMutation({
    onCompleted: data => {
      if (data.instagUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        navigate(instagramUrl(id));
      }
    }
  });

  return (
    <>
      <ShipmentDetailsPage
        onAdd={() => openModal("assign")}
        addInsTag={() => openModal("add-tag")}
        deleteInsTag={id =>
          instagramTagDelete({
            variables: {
              id
            }
          })
        }
        disabled={loading}
        shipment={data?.shipment}
        onSubmit={handleSubmit}
        onBack={() => navigate(shipmentListUrl())}
        saveButtonBarState={updateInstagramOpts.status}
        onNextPage={null}
        onPreviousPage={null}
        toolbar={
          <Button
            color="primary"
            onClick={() =>
              openModal("unassign", {
                ids: listElements
              })
            }
          >
            <FormattedMessage
              defaultMessage="Unassign"
              description="unassign product from collection, button"
            />
          </Button>
        }
        toolbarTag={
          <Button
            color="primary"
            onClick={() =>
              openModal("unassignTag", {
                ids: listElements
              })
            }
          >
            <FormattedMessage
              defaultMessage="Delete"
              description="Delete tag"
            />
          </Button>
        }
        toggleAll={toggleAll}
        isChecked={isSelected}
        selected={listElements.length}
        toggle={toggle}
        onRowClick={id => () => navigate(productUrl(id))}
        // onRowTagClick={id => () => {
        //   setProductVariant(
        //     data?.instagram?.instagramtag?.find(tag => id === tag.id)
        //       ?.productvariant?.sku
        //   );
        //   openModal("updateTag", { id });
        // }}
        onProductUnassign={(productId, event) => {
          event.stopPropagation();
          openModal("unassign", {
            ids: [productId]
          });
        }}
        fetchMoreVariants={{
          hasMore: resultVariants.data?.search.pageInfo.hasNextPage,
          loading: resultVariants.loading,
          onFetchMore: loadMoreVariants
        }}
        fetchVariants={searchVariants}
        variants={variants}
      />
      <AssignProductDialog
        confirmButtonState={assignProductInsOpts.status}
        hasMore={result.data?.search?.pageInfo.hasNextPage}
        open={params.action === "assign"}
        onFetch={search}
        onFetchMore={loadMore}
        loading={result.loading}
        onClose={closeModal}
        onSubmit={products =>
          assignProductIns({
            variables: {
              ...paginationState,
              instagramId: id,
              products: products.map(product => product.id)
            }
          })
        }
        products={mapEdgesToItems(result?.data?.search)?.filter(
          suggestedProduct => suggestedProduct.id
        )}
      />
      <ActionDialog
        confirmButtonState={unassignProductOpts.status}
        onClose={closeModal}
        onConfirm={() =>
          unassignProduct({
            variables: {
              instagramId: id,
              productIds: params.ids
            }
          })
        }
        open={params.action === "unassign"}
        title={intl.formatMessage({
          defaultMessage: "Unassign products from Instagram",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="{counter,plural,one{Are you sure you want to unassign this product?} other{Are you sure you want to unassign {displayQuantity} products?}}"
            values={{
              counter: maybe(() => {
                if (typeof params?.ids === "string") {
                  return 1;
                } else {
                  return params?.ids?.length;
                }
              }),
              displayQuantity: (
                <strong>{maybe(() => params?.ids?.length)}</strong>
              )
            }}
          />
        </DialogContentText>
      </ActionDialog>
      <ActionDialog
        confirmButtonState={instagramBulkDeleteTagOpts.status}
        onClose={closeModal}
        onConfirm={() =>
          instagramBulkDeleteTag({
            variables: {
              ids: params.ids
            }
          })
        }
        open={params.action === "unassignTag"}
        title={intl.formatMessage({
          defaultMessage: "Unassign tag from instagram",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="{counter,plural,one{Are you sure you want to delete this tag?} other{Are you sure you want to delete {displayQuantity} tags?}}"
            values={{
              counter: maybe(() => {
                if (typeof params?.ids === "string") {
                  return 1;
                } else {
                  return params?.ids?.length;
                }
              }),
              displayQuantity: (
                <strong>{maybe(() => params?.ids?.length)}</strong>
              )
            }}
          />
        </DialogContentText>
      </ActionDialog>
    </>
  );
};

export default ShipmentDetails;
